import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import {useHistory, useParams} from 'react-router-dom';
import {ClipLoader} from 'react-spinners';
import ButtonCircle from '../../components/Common/ButtonCircle';
import {RadarChart} from '../../components/CommonComponents';
import {ExploreSoftSkills, RmInfo} from '../../components/CompanyComponents';
import {FollowRmDisclaimer} from '../../components/Dialog/FollowRmDisclaimer';
import {openAlert} from '../../slices/alert';
import {openDialog} from '../../slices/dialog';
import {selectCv, selectUser} from '../../slices/profile';
import {selectSelectedCompany, selectSelectedRm, storeSelectedCompany, storeSelectedRm} from '../../slices/selected';
import {getCompanyById, getRm} from '../../api/company';
import InfoIcon from "@material-ui/icons/Info";
import {
    getDoneTotalMandatorySkills,
    getDoneTotalNotOptionalJobs,
    getDoneTotalNotOptionalQualifications,
    getDoneTotalOptionalJobs,
    getDoneTotalOptionalQualifications,
    getDoneTotalOptionalSkills
} from '../../helpers/misc';
import {isUserVerified} from '../../helpers/auth';
import {auth} from '../../firebase';
import moment from "moment";
import {Cookies} from "react-cookie-consent";
import {StudentRmTutorial} from '../../components/Dialog/StudentRmTutorial';
import {useTranslation} from 'react-i18next';
import {ROUTES} from '../../db/models/const';
import {incrementCompanyRmStatsView} from '../../api/company/rmStats';
import {getContentsByRmId} from '../../api/content';
import {studentFollowingRmIdArray} from "../../helpers/student";

var emojiCompact = require('emoji.json/emoji-compact.json')

export const StudentRm = () => {
    const dispatch = useDispatch();
    const {rmId} = useParams();
    const rm = useSelector(selectSelectedRm);
    // const rmId = useSelector(selectSelectedRmId);
    const user = useSelector(selectUser);
    const cv = useSelector(selectCv);
    // const companyId = useSelector(selectSelectedCompanyId);
    const company = useSelector(selectSelectedCompany);
    const [logoUrl, setLogoUrl] = useState("");
    const [loading, setLoading] = useState(true);
    const history = useHistory();
    const [qualCounters, setQualCounters] = useState();
    const [jobCounters, setJobCounters] = useState();
    const [skillCounters, setSkillCounters] = useState();
    // const [isTourOpen, setIsTourOpen] = useState(true);
    const [disableFollow, setDisableFollow] = useState();
    const [video, setVideo] = useState();
    const {t} = useTranslation();

    useEffect(() => {
        document.body.scrollIntoView();

        setDisableFollow(false);
    }, []);

    useEffect(() => {
        if (!rmId) {
            history.push(ROUTES.ME);
            return;
        }

        getRmAndPosts();
    }, [rmId]);

    useEffect(() => {
        if (!rmId) return;

        getContentsByRmId(rmId).then(contents => {
            setVideo(contents?.[0]);
        });
    }, [rmId])

    const getRmAndPosts = async () => {
        const rm = await getRm(rmId);

        setLoading(false);

        if (!rm) {
            history.push(ROUTES.ME);
            return;
        }

        if (rm?.coming) {
            history.push(ROUTES.STUDENT_RM_COMING.replace(":rmId", rmId));
            return;
        } else {
            if (!user?.demo) incrementCompanyRmStatsView(rmId);

            dispatch(storeSelectedRm({rm}));
        }
    }

    useEffect(() => {
        if (rm) {
            getCompanyById(rm.companyId).then(company => {
                dispatch(storeSelectedCompany({company}));
                setLogoUrl(company?.logoUrl);
            })
        }

        setQualCounters({
            optional: getDoneTotalOptionalQualifications(rm, cv),
            mandatory: getDoneTotalNotOptionalQualifications(rm, cv)
        });

        setJobCounters({
            optional: getDoneTotalOptionalJobs(rm, cv),
            mandatory: getDoneTotalNotOptionalJobs(rm, cv)
        });

        setSkillCounters({
            optional: getDoneTotalOptionalSkills(rm, cv),
            mandatory: getDoneTotalMandatorySkills(rm, cv)
        });

    }, [rm]);

    useEffect(() => {
        const tutorialDone = Cookies.get("rmTutorialDone");
        if (!tutorialDone)
            dispatch(openDialog({
                Content: StudentRmTutorial,
                title: "",
                props: {},
                closable: false,
                narrow: true
            }));
    }, [])

    const onFollowClick = () => {
        // check user verification only on not demo users
        if (!user?.demo) {
            // if not verified, deny follow if n days have passed from signup time
            const signed = moment(auth.currentUser.metadata.creationTime);
            const now = moment();
            const diff = moment.duration(now.diff(signed));
            const days = diff.asDays();
            if (!isUserVerified() && days > 5) {
                dispatch(openAlert({type: "warning", message: t("alert_verify_account")}));
                return;
            }
        }

        const followIds = studentFollowingRmIdArray(user);
        if (followIds.includes(rm.id)) {
            dispatch(openAlert({type: "warning", message: t("alert_rm_already_followed")}));
            return;
        }

        if (!(company?.rmTerms)) {
            dispatch(openAlert({type: "info", message: t("alert_rm_privacy")}));
            return;
        }

        dispatch(openDialog({
            Content: FollowRmDisclaimer,
            title: t("student_followDisclaimer_title"),
            closable: true
        }));
    };

    const onSoftExploreClick = () => {
        dispatch(openDialog({
            Content: ExploreSoftSkills,
            title: "Soft Competencies",
            props: {
                softSkillsExplanation: rm.softSkillsExplanation,
            },
            closable: true
        }));
    }

    // useEffect(() => {
    //     if (!rm) return;
    //     getGames(rm.id).then(games => setGames(games || []));
    // }, [rm]);

    return (
        <div className="studentRm">
            {!loading && <>
                {/*This sections is not needed any more*/}
                {/*<SectionNavbar>*/}
                {/*    <h2 onClick={() => history.push(ROUTES.COMPANY.replace(":companyId", company?.id))}>*/}
                {/*        <span className="nav">{company?.name}</span>*/}
                {/*        {" > "}*/}
                {/*        <span>{rm?.name}</span>*/}
                {/*    </h2>*/}
                {/*    <button className="button followButton" onClick={() => onFollowClick()} disabled={disableFollow}>*/}
                {/*        {t("student_rm_joinButton")}*/}
                {/*    </button>*/}
                {/*</SectionNavbar>*/}

                <h2 className="studentRm__title">{t("student_rm_generalTitle", {rmName: rm?.name})}</h2>
                <p className="studentRm__subtitle">{t("student_rm_generalSubtitle")}</p>
                <div className="studentRm__topCards">
                    <div className="studentRm__rmInfo card">
                        <RmInfo rm={rm} logoUrl={logoUrl} video={video}/>
                    </div>
                    <div className="card studentRm__radar">
                        <div className={"d-flex justify-content-end"}>
                            <ButtonCircle onClick={() => onSoftExploreClick()}><InfoIcon/></ButtonCircle>
                        </div>
                        <RadarChart softSkills={rm?.softSkills} onClick={() => {
                        }}/>
                    </div>
                </div>
                <button className="mx-2 button followButton" onClick={() => onFollowClick()}
                        disabled={disableFollow}>
                    {t("student_rm_joinButton")}
                </button>

                {/*These section is useless to be shown*/}
                {/*<h2 className="studentRm__title mt30">{t("student_rm_itemsTitle")}</h2>*/}
                {/*<p className="studentRm__subtitle">{t("student_rm_itemsSubtitle")}</p>*/}
                {/*<div className="studentRm__kpi">*/}
                {/*    <div className="card studentRm__summary">*/}
                {/*        <div className="summary__left">*/}
                {/*            <p>{emojiCompact[3843]}</p>*/}
                {/*            <label>{t("student_rm_qual")}</label>*/}
                {/*        </div>*/}
                {/*        <div className="divider"></div>*/}
                {/*        <div className="summary__right">*/}
                {/*            <label>{t("student_rm_goals")}</label>*/}
                {/*            <p className="mandatory">{t("student_rm_mandatory") + " | "}<strong>{qualCounters?.mandatory?.done}/{qualCounters?.mandatory?.total}</strong>*/}
                {/*            </p>*/}
                {/*            <p className="niceToHave">{t("student_rm_optional") + " | "}<strong>{qualCounters?.optional?.done}/{qualCounters?.optional?.total}</strong>*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*    <div className="card studentRm__summary">*/}
                {/*        <div className="summary__left">*/}
                {/*            <p>{emojiCompact[3894]}</p>*/}
                {/*            <label>{t("student_rm_job")}</label>*/}
                {/*        </div>*/}
                {/*        <div className="divider"></div>*/}
                {/*        <div className="summary__right">*/}
                {/*            <label>{t("student_rm_goals")}</label>*/}
                {/*            <p className="mandatory">{t("student_rm_mandatory") + " | "}<strong>{jobCounters?.mandatory?.done}/{jobCounters?.mandatory?.total}</strong>*/}
                {/*            </p>*/}
                {/*            <p className="niceToHave">{t("student_rm_optional") + " | "}<strong>{jobCounters?.optional?.done}/{jobCounters?.optional?.total}</strong>*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*    <div className="card studentRm__summary">*/}
                {/*        <div className="summary__left">*/}
                {/*            <p>{emojiCompact[3938]}</p>*/}
                {/*            <label>{t("student_rm_skills")}</label>*/}
                {/*        </div>*/}
                {/*        <div className="divider"></div>*/}
                {/*        <div className="summary__right">*/}
                {/*            <label>{t("student_rm_goals")}</label>*/}
                {/*            <p className="mandatory">{t("student_rm_mandatory") + " | "}<strong>{skillCounters?.mandatory?.done}/{skillCounters?.mandatory?.total}</strong>*/}
                {/*            </p>*/}
                {/*            <p className="niceToHave">{t("student_rm_optional") + " | "}<strong>{skillCounters?.optional?.done}/{skillCounters?.optional?.total}</strong>*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*    <div className="card studentRm__summary">*/}
                {/*        <div className="summary__left">*/}
                {/*            <p>{emojiCompact[3685]}</p>*/}
                {/*            <label>{t("student_rm_game")}</label>*/}
                {/*        </div>*/}
                {/*        <div className="divider"></div>*/}
                {/*        <div className="summary__right">*/}
                {/*            <p className="niceToHave">{t("student_rm_gameTotal") + " | "}<strong>{rm?.gameCount || 0}</strong>*/}
                {/*            </p>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
            </>}
            {loading && <ClipLoader size={50} color={"#7400b8"} loading={true}/>}
            {/* <Tour
				steps={tourSteps}
				isOpen={isTourOpen}
				onRequestClose={() => setIsTourOpen(false)}
			/> */}
        </div>
    )
}
